/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_Today_MoreInputs */

const en_directory_home_board_today_more = /** @type {(inputs: Directory_Home_Board_Today_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earlier launches`)
};

const zh_directory_home_board_today_more = /** @type {(inputs: Directory_Home_Board_Today_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更早发布`)
};

/**
* | output |
* | --- |
* | "Earlier launches" |
*
* @param {Directory_Home_Board_Today_MoreInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_today_more = /** @type {((inputs?: Directory_Home_Board_Today_MoreInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_Today_MoreInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_today_more(inputs)
	return zh_directory_home_board_today_more(inputs)
});
export { directory_home_board_today_more as "directory.home.board.today_more" }